import { useContext } from 'react'
import { PlanTypeSelectorContext } from '../contexts'

export const usePlanTypeSelectorContext = () => ({
  showInkPaperPlansOnPlanTypeSelector: false,
  setHasSelectedPlan: () => {
    throw new Error('setHasSelectedPlan is not implemented')
  },
  ...(useContext(PlanTypeSelectorContext) || {})
})
